/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signin_With_ProviderInputs */

const en_auth_signin_with_provider = /** @type {(inputs: Auth_Signin_With_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const es_auth_signin_with_provider = /** @type {(inputs: Auth_Signin_With_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión con`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Auth_Signin_With_ProviderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_signin_with_provider = /** @type {((inputs?: Auth_Signin_With_ProviderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signin_With_ProviderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_signin_with_provider(inputs)
	return en_auth_signin_with_provider(inputs)
});